import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { FaTools, FaCalculator, FaLightbulb, FaBolt, FaMicrochip } from 'react-icons/fa'
import ResistorCalculator from './calculators/ResistorCalculator'
import OhmsLawCalculator from './calculators/OhmsLawCalculator'
import LEDResistorCalculator from './calculators/LEDResistorCalculator'
import VoltageDividerCalculator from './calculators/VoltageDividerCalculator'
import CapacitorCalculator from './calculators/CapacitorCalculator'
import './Tools.css'

const Tools = () => {
  const [activeTab, setActiveTab] = useState('resistor')

  const tools = [
    { id: 'resistor', name: 'Resistor Color Code', icon: <FaMicrochip /> },
    { id: 'ohms', name: "Ohm's Law", icon: <FaBolt /> },
    { id: 'led', name: 'LED Resistor', icon: <FaLightbulb /> },
    { id: 'divider', name: 'Voltage Divider', icon: <FaCalculator /> },
    { id: 'capacitor', name: 'Capacitor Code', icon: <FaMicrochip /> }
  ]

  return (
    <div className="tools">
      {/* Hero Section */}
      <section className="tools-hero section-padding">
        <div className="container">
          <motion.div
            className="tools-hero-content text-center"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1><FaTools /> Electronics Tools</h1>
            <p>Useful calculators and tools for electronics engineers and hobbyists</p>
          </motion.div>
        </div>
      </section>

      {/* Tools Navigation */}
      <section className="tools-nav section-padding bg-secondary">
        <div className="container">
          <motion.div
            className="tools-tabs"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            {tools.map((tool) => (
              <button
                key={tool.id}
                className={`tool-tab ${activeTab === tool.id ? 'active' : ''}`}
                onClick={() => setActiveTab(tool.id)}
              >
                {tool.icon} {tool.name}
              </button>
            ))}
          </motion.div>
        </div>
      </section>

      {/* Tools Content */}
      <section className="tools-content section-padding">
        <div className="container">
          <motion.div
            className="tool-container card"
            key={activeTab}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.4 }}
          >
            {activeTab === 'resistor' && <ResistorCalculator />}
            {activeTab === 'ohms' && <OhmsLawCalculator />}
            {activeTab === 'led' && <LEDResistorCalculator />}
            {activeTab === 'divider' && <VoltageDividerCalculator />}
            {activeTab === 'capacitor' && <CapacitorCalculator />}
          </motion.div>
        </div>
      </section>
    </div>
  )
}

export default Tools
